import { RemoteLoadProjectList } from '@/javascript/data/usecases'
import { LoadProjectList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import {  makeApiUrl } from '../http'

export const makeRemoteLoadProjectList = (): LoadProjectList =>
  new RemoteLoadProjectList(makeApiUrl('/projects'), makeCurrentAccountHttpClientDecorator())